export default "__VITE_ASSET__B18WCzil__"